import clsx from "clsx";
import { useState, type ReactNode } from "react";
import { Header } from "../components/common/BrowseListing/header";

interface BrowseListing {
  children: ReactNode;
  customBg?: boolean;
  pb?: string;
  isShowProperty?: boolean;
  fullWidthProperty?: boolean;
}
const BrowseListingLayout = ({
  children,
  customBg = false,
  pb = "120px",
  isShowProperty = false,
  fullWidthProperty = false,
}: BrowseListing) => {
  const [showOfferBanner, setShowOfferBanner] = useState(false);
  return (
    <div>
     
        <Header
          showOfferBanner={showOfferBanner}
          setShowOfferBanner={setShowOfferBanner}
        />
    
      <div
        style={{
          background: customBg
            ? "linear-gradient(180deg, rgba(159, 225, 120, 0.00) 0%, rgba(159, 225, 120, 0.10) 100%), #FFF"
            : "#fff",
          paddingBottom: isShowProperty ? "45px" : pb,
        }}
        className="pt-10"
      >
        <div
          className={clsx(
            isShowProperty && fullWidthProperty === false
              ? "px-12"
              : "container mx-auto"
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export { BrowseListingLayout };
